import Bugsnag from '@bugsnag/js'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-ultimate'
import useReCaptchaEnabled from './useReCaptchaEnabled'

const getReCaptchaToken = async (
  executeV3: ReturnType<typeof useGoogleReCaptcha>['executeV3'] | null,
) => {
  if (!executeV3) {
    console.warn('Execute reCaptcha not available')
    return
  }

  if (
    !process.env.NEXT_PUBLIC_GOOGLE_CLOUD_PROJECT_ID ||
    !process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY
  ) {
    console.warn('ReCaptcha keys not available')
    return
  }

  return executeV3('submit')
}

/**
 * Only attempts to get a token if Google ReCaptcha is enabled for the current campaign.
 * @returns {Promise<string | undefined>} Google ReCaptcha token
 */
const useReCaptchaToken = () => {
  const [token, setToken] = useState<string | undefined>()
  const { executeV3 } = useGoogleReCaptcha()

  const isReCaptchaEnabled = useReCaptchaEnabled()

  useEffect(() => {
    if (!isReCaptchaEnabled || typeof executeV3 !== 'function') {
      return
    }

    getReCaptchaToken(executeV3)
      .then(setToken)
      .catch((error) => {
        const log = 'Error getting reCaptcha token: ' + error
        console.error(log)
        Bugsnag.notify(log)
      })
  }, [executeV3, isReCaptchaEnabled])

  return token
}

export default useReCaptchaToken
